import type { Brand } from '../interfaces/brand/brand.interface';

/**
 * Whether the brand lists the workspace. GET /api/brands sends workspace ids, but a brand cached in
 * localStorage before that change still holds workspace objects until setMyBrand() rewrites it.
 */
export const brandHasWorkspace = (brand: Brand | null | undefined, workspaceId: string): boolean =>
  (brand?.workspaces ?? []).some(
    (workspace: string | { id?: string }) => (typeof workspace === 'string' ? workspace : workspace?.id) === workspaceId
  );
